/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCreateReportedAssetResponse
 */
export interface ControlCreateReportedAssetResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlCreateReportedAssetResponse
     */
    status: string;
}

/**
 * Check if a given object implements the ControlCreateReportedAssetResponse interface.
 */
export function instanceOfControlCreateReportedAssetResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function ControlCreateReportedAssetResponseFromJSON(json: any): ControlCreateReportedAssetResponse {
    return ControlCreateReportedAssetResponseFromJSONTyped(json, false);
}

export function ControlCreateReportedAssetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCreateReportedAssetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function ControlCreateReportedAssetResponseToJSON(value?: ControlCreateReportedAssetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

